import HubAboutTherapyModule from './HubAboutTherapyModule'

export default HubAboutTherapyModule
